import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import { Container, Logo, PreHeader } from '@scentregroup/ui'
import { getCentreStructuredData } from '../../helpers/get-centre-structured-data'
import getCentreOpenGraphData from '../../helpers/get-centre-open-graph-data'
import CentreFooter from '../../components/centre-footer'
import FeedbackButton from '../../components/feedback-button'
import Header from '../../components/header'
import withCentre from '../../containers/with-centre'
import containerStyle from '../../components/container.scss'
import { centreType } from '../../types'
import pagesHoc from '../pages-hoc'
import CentrePattern from '../../components/centre-pattern'
import {
  TimeZoneContext,
  CustomThemeContext,
  BasicPageContext,
  AgentInfoContext,
} from '../../context'
import { TouchEventDetection } from '../../helpers/with-touch-detection'
import fullCentreTitle from '../../helpers/full-centre-title'
import CentreRoutes from './centre-routes'
import style from './index.scss'

const isMapPage = ({ location }) => location.pathname.includes('centre-map')
const shouldAnimateW = true

class CentrePage extends React.Component {
  state = {
    firstPage: shouldAnimateW,
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.firstPage &&
      nextProps.location.pathname !== this.props.location.pathname
    ) {
      this.setState({
        firstPage: false,
      })
    }
  }

  render() {
    const { centre, ...otherProps } = this.props
    const { firstPage } = this.state
    const preHeaderColour =
      centre.bespoke && centre.bespoke.luxury ? 'minimal' : 'seasonal'
    return (
      <BasicPageContext.Consumer>
        {isBasicPage => (
          <TimeZoneContext.Provider value={centre.timeZone}>
            <CustomThemeContext.Provider value={centre.bespoke}>
              <TouchEventDetection className="fullHeightForMap">
                {!isBasicPage && (
                  <Fragment>
                    <CentrePattern slug={centre.slug} />
                    <AgentInfoContext.Consumer>
                      {({ isMobile }) =>
                        (!isMapPage(otherProps) || !isMobile) && (
                          <PreHeader colour={preHeaderColour}>
                            <Link
                              to="/"
                              title="Home"
                              className={style.headerLogo}
                            >
                              <Logo />
                            </Link>
                          </PreHeader>
                        )
                      }
                    </AgentInfoContext.Consumer>
                    <Header
                      centre={centre}
                      navigationMenu={centre.navigationMenu}
                    />
                  </Fragment>
                )}
                <Container
                  className={classNames(
                    containerStyle.relativelyPositioned,
                    containerStyle.containerSpaced,
                    containerStyle.allowForHeader,
                    'fullHeightForMap'
                  )}
                >
                  <CentreRoutes {...{ centre, firstPage }} />
                </Container>
                {!isBasicPage && (
                  <Fragment>
                    <div id="search-modal" />
                    {!isMapPage(otherProps) && (
                      <Fragment>
                        <CentreFooter centre={centre} />
                        <FeedbackButton emailAddress={centre.emailAddress} />
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </TouchEventDetection>
            </CustomThemeContext.Provider>
          </TimeZoneContext.Provider>
        )}
      </BasicPageContext.Consumer>
    )
  }
}

CentrePage.propTypes = {
  error: PropTypes.object,
  centre: centreType,
  location: PropTypes.object,
}

const getMetaData = ({ canonical, centre }) => {
  const title = fullCentreTitle(centre)
  const description = `Westfield ${
    centre.title
  } - your one-stop hub for shopping, fun & relaxation. Shop our range of fashion, entertainment, dining & wellbeing or check out great events & activities.`
  const metaAttributes = {
    url: canonical,
    centre,
    name: title,
    description,
  }
  return {
    title,
    description,
    openGraphData: getCentreOpenGraphData(metaAttributes),
    schema: getCentreStructuredData(metaAttributes),
  }
}

export const RawCentrePage = CentrePage

export default withRouter(withCentre(pagesHoc(RawCentrePage, getMetaData)))
